module.exports = __webpack_public_path__ + "img/alur-pendaftaran-paten.dc8611b4.png";